export { FooterToolbarComponent } from './footer-toolbar.component';
export { AdFooterToolbarModule } from './footer-toolbar.module';
